module.exports = new __parcel__URL__("moving_platform.3496ad5e.png").toString();